export const AppTranslations: Array<string> = [
    'Admin.Test123'
];
